import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import Expertise from '../components/Expertise';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';

const ExpertisePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      {/* Page Header */}
      <div className="pt-32 pb-12 px-4 bg-gradient-to-b from-teal-50 to-white">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Areas of Expertise
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive cancer care with international training and evidence-based treatment approaches
          </p>
        </div>
      </div>

      {/* Expertise Content */}
      <Expertise />

      {/* Additional Details */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Treatment Philosophy</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Our approach to cancer treatment combines cutting-edge medical science with compassionate patient care. We believe in treating the whole person, not just the disease.
              </p>
              <p className="text-gray-700 leading-relaxed mb-4">
                Every patient receives a personalized treatment plan developed through multidisciplinary tumor board discussions, considering the latest evidence-based guidelines and individual patient preferences.
              </p>
              <p className="text-gray-700 leading-relaxed">
                With international training from premier institutions including Princess Margaret Cancer Center (Toronto), ESMO programs, and ongoing participation in clinical research, we bring world-class cancer care to Northeast India.
              </p>
            </div>

            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Advanced Treatment Options</h2>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-2 h-2 bg-teal-700 rounded-full mt-2"></div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Precision Oncology</h3>
                    <p className="text-gray-600">Molecular profiling and targeted therapies based on tumor genetics</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-2 h-2 bg-teal-700 rounded-full mt-2"></div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Immunotherapy</h3>
                    <p className="text-gray-600">Latest checkpoint inhibitors and cellular therapies</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-2 h-2 bg-teal-700 rounded-full mt-2"></div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Chemotherapy</h3>
                    <p className="text-gray-600">Modern protocols with enhanced supportive care</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-2 h-2 bg-teal-700 rounded-full mt-2"></div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Integrated Palliative Care</h3>
                    <p className="text-gray-600">Symptom management and quality of life optimization</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 bg-gradient-to-r from-teal-700 to-teal-600">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-4xl font-bold mb-6">Ready to Discuss Your Treatment Options?</h2>
          <p className="text-xl mb-8 opacity-90">
            Schedule a consultation to explore personalized cancer care solutions
          </p>
          <Link to="/contact">
            <Button size="lg" variant="secondary" className="bg-white text-teal-700 hover:bg-gray-100 px-8 py-6 text-lg">
              Book Consultation
            </Button>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ExpertisePage;